module.exports = __webpack_public_path__ + "img/Currentsession.10d2b8d4.svg";